import { httpService } from '@/api/httpService'
const home = {
  state: {
    // 是否开启mate标签加密 默认不加密
    encryptionEnabledFlag:'N',
    projectVersion:{},
    homeInfo: {},
    HospitalLogo:'',
    historyData:[],
    shareInfo:{},
    verificationDialogVisible:false,
    verificationOnce:false,
    patientPhone:null//患者手机号
  },
  mutations: {
    SETENCRYPTINENABLEDFLAG(state,str){
      state.encryptionEnabledFlag = str;
    },
    SET_HOME_INFO: (state, info) => {
      state.homeInfo = info
    },
    SET_HISTORY_DATA:(state, data) => {
      state.historyData = data
    },
    SET_HOSPITAL_LOGO:(state, data) => {
      state.HospitalLogo = data
    },
    SETSHAREINFO:(state, data)=>{
      state.shareInfo = data
    },
    VERIFICATIONDIALOGVISIBLE:(state, B)=>{
      state.verificationDialogVisible = B
    },
    PROJECTVERSION(state,info){
      state.projectVersion = Object.assign(state.projectVersion,info)
      console.log( state.projectVersion)
    },
    PATIENTPHONE(state,phone){
      state.patientPhone = phone
    },
    VERIFICATIONONCE(state, B){
      state.verificationOnce = B
    },
    BUTTONCFG(state, list){
      state.buttonCfg = list
    }
  },
  actions: {
    // 获取医院配置
    getDispConfig({commit},params){
      return new Promise((resolve, reject) => {
        httpService({
          url: 'getDispConfig',
          method: 'get',
          params: params
        }).then(response => {
          let { result } = response;
          // result.encryptionEnabledFlag = "Y";
          commit('SETENCRYPTINENABLEDFLAG',result.encryptionEnabledFlag)
          commit('SET_HOSPITAL_LOGO',result.imageUrl)
          resolve(response)
        })
      })
    },
    getHomeInfo ({ commit }, params) {
      return new Promise((resolve, reject) => {
        httpService({
          url: 'getHomeData',
          method: 'get',
          params: params
        }).then(response => {

          if(!response){
            resolve(response)
            return 
          }
          response.result.REPORT.forEach((ele) => {
            if (ele.tcPtGender === 'F') {
              ele.tcPtGender = '女'
            } else if (ele.tcPtGender === 'M') {
              ele.tcPtGender = '男'
            }
          })
          commit('SET_HOME_INFO', response.result)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getHospitalLogo({ commit }, params){
      return new Promise((resolve, reject) => {
        httpService({
          url: 'getHospitalLogo',
          method: 'get',
          data: params
        })
        .then(response => {
          if(response){
            commit('SET_HOSPITAL_LOGO',response.result.imageUrl)
          }
        })
      })
    },
    getShareInfo({ commit }, params){
      return new Promise((resolve, reject) => {
        httpService({
          url: 'getQrcodeRule',
          method: 'get',
          params: params
        })
        .then(response => {
          if(response){
            resolve(response.result)
          }
        })
      })
    },
    getQRcodeCreate({ commit }, params){
      return new Promise((resolve, reject) => {
        httpService({
          url: 'qr_codeCreate',
          method: 'get',
          params: params
        })
        .then(response => {
          if(response){
            commit('SETSHAREINFO', response.result)
          }
        })
      })
    },
    loginCheck({ commit }, data){
      return new Promise((resolve, reject) => {
        httpService({
          url: 'loginCheck',
          method: 'post',
          data: data
        }).then(response => {
          resolve(response)
        })
      })
    },
    verificationDialogVisible({commit},B){
      commit('VERIFICATIONDIALOGVISIBLE', B)
    },
    verificationOnce({commit},B){
      commit('VERIFICATIONONCE', B)
    },
    // 版本信息
    getProjectVersion({commit}){
      return new Promise((resolve, reject) => {
        httpService({
          url: 'projectVersion',
          method: 'post',
        }).then(response => {
          resolve(response)
          commit('PROJECTVERSION', response.result)
        })
      })
    },
    // 获取手机验证码
    sendVerification({ commit }, data){
      return new Promise((resolve, reject) => {
        httpService({
          url: 'sendVerification',
          method: 'post',
          data: data
        }).then(response => {
          resolve(response)
        })
      })
    },
    // 获取患者手机号
    getPatientPhone({commit},data){
      return new Promise((resolve, reject) => {
        httpService({
          url: 'getPatientPhone',
          method: 'post',
          data: data
        }).then(response => {
          commit('PATIENTPHONE',response.result)
          resolve()
        })
      })
    },
    // 获取按钮配置
    getDicByFieldName({commit},params){
      return new Promise((resolve, reject) => {
        httpService({
          url: 'getDicByFieldName',
          method: 'get',
          params: params
        }).then(response => {
          commit('BUTTONCFG',response.result)
          resolve(response.result)
        })
      })
    }
  }
}

export default home
